import React, { useState } from "react";
import upArrow from "../../assets/pic/upArrow.svg";
import downArrow from "../../assets/pic/downArrow.svg";
import { LayoutForLandingPage } from "./Home";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    // {
    //   question: "How many cards do I get per month?",
    //   answer:
    //     "We’re currently only offering a 4-card/month subscription option for now, but we do plan to provide more options in the future. So, stay tuned.",
    // },
    {
      question: "Can I purchase a single card?",
      answer:
        "Yes you can now make single-card purchases. However, the cost per card is cheaper if you subscribe.",
    },

    {
      question: "If I subscribe, how many cards to I get per month?",
      answer:
        "Under the subscription plan, you get 4-cards per month. However, you can make single card purchases too.",
    },

    {
      question:
        "When do I need to schedule my cards to make sure my recipient receives their card?",
      answer:
        "You must schedule your card at least 8 days prior to the event date. We will send out email reminders to make sure you schedule your cards on time.",
    },
    {
      question: "Do unused cards roll over to the next month?",
      answer: "No, unused cards do not roll over to the next month.",
    },
    // {
    //   question: "Can I purchase a single card?",
    //   answer:
    //     "Currently, we only offer subscription plans. However, we plan to introduce a single-card purchase option in the future.",
    // },
    {
      question: "How long does it take for a card to arrive?",
      answer: "Typically, cards take 3-6 business days to arrive.",
    },
    {
      question: "Will the card arrive on the exact date of the event?",
      answer:
        "While we can't guarantee the exact delivery dates, we will do our best to make sure your card arrives no later than the scheduled event date.",
    },
    {
      question: "Can I cancel my subscription at any time?",
      answer: "Yes, you can cancel your subscription at any time.",
    },
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <div className="flex flex-col justify-center items-center py-8">
      <h2 className="lg:text-5xl text-2xl font-bold mb-4">
        Frequently <span className="text-[#F66061]">Asked Questions</span>
      </h2>
      <LayoutForLandingPage>
        <div className="w-full rounded-md shadow-md">
          {faqs.map((faq, index) => (
            <div key={index} className="w-full">
              <div
                className="flex justify-between items-center cursor-pointer p-4 border-b bg-white"
                onClick={() => toggleAccordion(index)}
              >
                <h3 className="font-semibold md:text-[21px] text-[16px]">
                  {faq.question}
                </h3>
                <img
                  src={activeIndex === index ? downArrow : upArrow}
                  alt={activeIndex === index ? "Collapse" : "Expand"}
                  className="ml-2"
                />
              </div>
              {/* {activeIndex === index && (
                <div className="p-4 bg-gray-100 border-b border-gray-300 transition-all duration-200">
                  <p className="text-[16px] font-[400]">{faq.answer}</p>
                </div>
              )} */}
              <div
                className={`overflow-hidden transition-all duration-300 ease-in-out ${
                  activeIndex === index
                    ? "max-h-[500px] opacity-100"
                    : "max-h-0 opacity-0"
                }`}
              >
                <div className="p-4 bg-gray-100 border-b border-gray-300">
                  <p className="text-[16px] font-[400]">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </LayoutForLandingPage>
    </div>
  );
};

export default FAQ;
